angular
    .module('eficienciaFiscalModule')
    .component('efEtiqueta', {
        controller: function() {
            return {
                get textColor() {
                    return cbk.blackOrWhiteBasedOnBackground(this.cor, 0.6)
                }
            }
        },
        bindings: {
            nome: '@',
            cor: '@',
            descricao: '@'
        },
        template: `
            <div 
                tooltip="{{$ctrl.descricao}}" 
                class="label" 
                style="display: inline-block; background-color: #{{$ctrl.cor}}">
                <span style="color: #{{$ctrl.textColor}}">
                    {{$ctrl.nome}}
                </span>
            </div>
        `
    })
